// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-components-Layout-MainContent-_powa2","center":"styles-module__center__src-labstep-web-components-Layout-MainContent-_hWXXY"};